import { css } from "@emotion/core";
import { fontTypes, fontWeight, color } from "../../constants/commons";

export const workplaceDetailsStyle = css`
  .outer-speed-container {
    background: ${color.ligitishGreenShadow};
    border-radius: 0.25em;
    border: 0.0625em solid ${color.green};
    min-height: 4.8125em;
  }
  .ant-radio-group {
    margin-left: -0.5em;
  }
  .display-content-style {
    color: ${color.lightishGray};
  }
  .success-description {
    color: ${color.green};
    font-family: ${fontTypes.bodyFont};
    font-weight: ${fontWeight.medium};
  }
  .wifi-connection-text {
    color: ${color.darkRed};
    font-family: ${fontTypes.bold};

    font-weight: ${fontWeight.medium};
    text-transform: uppercase;
  }
  .internet-connectivity-block-info {
    background: ${color.white};
    border-radius: 0.25em;
    border: 1px solid ${color.gray};
    min-height: 4.25em;
    padding: 1em;
  }
  .internet-connectivity-block-info-tabmonitor {
    background: ${color.whitishGray};
    border-radius: 0.25em;
    min-height: 4.8125em;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .logo-responsive-styling {
      width: 25%;
      align-self: baseline;
    }
    .wifi-responsive-width-style {
      width: 10%;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .logo-responsive-styling {
      width: 8%;
      align-self: baseline;
    }
    .wifi-responsive-width-style {
      width: 5%;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .logo-responsive-styling {
      width: 4%;
      align-self: baseline;
    }
    .wifi-responsive-width-style {
      width: 4%;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .logo-responsive-styling {
      width: 3%;
      align-self: center;
    }
    .wifi-responsive-width-style {
      width: 3%;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .logo-responsive-styling {
      width: 3%;
      align-self: center;
    }
    .wifi-responsive-width-style {
      width: 3%;
    }
  }
`;
